import React from 'react'
import { FileDrop } from 'react-file-drop'

import './UploadFile.scss'

const UploadFile = ({setKey}) => {
   const ref = React.useRef()

   const handleDrop = (files, event) => {
      ref.current = files
      const fr=new FileReader();
      fr.onload=function(){
         setKey(fr.result);
      }
      fr.readAsText(files[0]);
   }

   const onChange = (e) => {
      const files = e.target.files;
      console.log(ref)
      const fr=new FileReader();
      fr.onload=function(){
         setKey(fr.result);
      }
      fr.readAsText(files[0]);
   }

   return (
      <div className="UploadFile">
         <FileDrop
            onFrameDragEnter={event => console.log('onFrameDragEnter', event)}
            onFrameDragLeave={event => console.log('onFrameDragLeave', event)}
            onFrameDrop={event => console.log('onFrameDrop', event)}
            onDragOver={event => console.log('onDragOver', event)}
            onDragLeave={event => console.log('onDragLeave', event)}
            onDrop={(files, event) => handleDrop(files, event)}
            // onTargetClick={() => ref.current.click()}}
         >
            Drag and drop file or <input type="file" ref={ref} onChange={(e) => { onChange(e); }} />
         </FileDrop>
         
      </div>
   )
}

export default UploadFile
